export enum realm {
    BRIGHTTALK = '1',
    ANONYMOUS = '2'
}
